/* eslint-disable */
import { DocumentNode } from 'graphql';
import { addClientAlwaysDirectiveLogic } from 'src/database/addClientAlwaysDirectiveLogic.ts';




export const addClientAlwaysDirective = (doc: DocumentNode): DocumentNode => {
    if (import.meta.env.VITE_MOCKED === 'on') {
        return doc;
    }
    return addClientAlwaysDirectiveLogic(doc);
}

